import { get } from 'lodash';
import { IndependentAdviceTypeRequired } from '@lendi/core-constants';

import { FIELD_PATHS } from '@funnels/constants';
import { useFormValues } from '@funnels/hooks';
import { BrokerInterviewsGuarantorEntityIndex } from '@funnels/types';

import { FunnelGrid, FunnelGridUnit } from '../../../Common';
import { CheckboxField, RadioButtonsField } from '../../../Fields';

export const OPTIONS = [
  { label: 'Seeking independent legal advice', value: IndependentAdviceTypeRequired.legalAdvice },
  { label: 'Seeking financial advice', value: IndependentAdviceTypeRequired.financialAdvice },
  { label: 'Not needed', value: IndependentAdviceTypeRequired.notNeeded },
];

export const IndependentAdvice = ({ brokerInterviewsGuarantorIndex }: BrokerInterviewsGuarantorEntityIndex) => {
  const [formValues, setFormValue] = useFormValues();

  const selected = get(
    formValues,
    FIELD_PATHS.BROKER_INTERVIEWS_GUARANTOR_INDEPENDENT_ADVICE_TYPE_REQUIRED(brokerInterviewsGuarantorIndex)
  );
  const displayAwareness = [
    IndependentAdviceTypeRequired.financialAdvice,
    IndependentAdviceTypeRequired.notNeeded,
  ].includes(selected);

  const handleOnAdviceChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const newSelection = e.target.value as IndependentAdviceTypeRequired;
    if (
      ![IndependentAdviceTypeRequired.financialAdvice, IndependentAdviceTypeRequired.notNeeded].includes(newSelection)
    ) {
      setFormValue(
        FIELD_PATHS.BROKER_INTERVIEWS_GUARANTOR_UNDERSTANDS_GUARANTEE_SIGNING_PERIOD(brokerInterviewsGuarantorIndex),
        undefined
      );
    }
  };

  return (
    <FunnelGrid>
      <FunnelGrid mt="md" mb="lg">
        <FunnelGridUnit size={1 / 2}>
          It is strongly recommended for the guarantor to seek independent legal or financial advice. What is the
          guarantor's decision on independent advice?
        </FunnelGridUnit>
        <FunnelGridUnit size={1 / 2}>
          <RadioButtonsField
            name={FIELD_PATHS.BROKER_INTERVIEWS_GUARANTOR_INDEPENDENT_ADVICE_TYPE_REQUIRED(
              brokerInterviewsGuarantorIndex
            )}
            radios={OPTIONS}
            size="sm"
            isBoxed={false}
            noVerticalSpace
            selectedValue={get(
              formValues,
              FIELD_PATHS.BROKER_INTERVIEWS_GUARANTOR_INDEPENDENT_ADVICE_TYPE_REQUIRED(brokerInterviewsGuarantorIndex)
            )}
            onChange={handleOnAdviceChange}
            isOptional
          />
        </FunnelGridUnit>
      </FunnelGrid>
      {displayAwareness && (
        <FunnelGrid mb="lg">
          <FunnelGridUnit size={1 / 2}>
            Are you aware that under the Banking Code of Practice, you have at least 3 days to read and review the
            Guarantee and other documents that we are required to provide to you before returning the signed Guarantee?
            If you have obtained independent legal advice or; if another exception in the Banking Code of Practice
            applies, you may return the documents earlier.
          </FunnelGridUnit>
          <FunnelGridUnit size={1 / 2}>
            <CheckboxField
              name={FIELD_PATHS.BROKER_INTERVIEWS_GUARANTOR_UNDERSTANDS_GUARANTEE_SIGNING_PERIOD(
                brokerInterviewsGuarantorIndex
              )}
              size="sm"
              checkboxLabel="The guarantor understands and wants to proceed"
              isOptional
            />
          </FunnelGridUnit>
        </FunnelGrid>
      )}
    </FunnelGrid>
  );
};
